import { FC, MouseEventHandler, useEffect, useState } from "react";
import { ReactComponent as LockIcon } from "@images/lock.shield.fill.svg";
import { ReactComponent as ExitIcon } from "@images/exit_icon.svg";
import * as analyticsManager from "@utils/managers/AnalyticsManager";

export enum OauthPrivacyPopupState {
    hidden,
    visible
}

const OauthPrivacyPopup = (props) => {
	const [isVisible, setVisible] = useState(false);
	const [isLearnMore, setIsLearnMore] = useState(props?.isLearnMore ?? false);

	useEffect(() => {
		if (props.popupState !== OauthPrivacyPopupState.hidden) {
			document.body.style.overflow = "hidden";
			setVisible(true);
		}

		if (props.popupState === OauthPrivacyPopupState.hidden) {
			setTimeout(() => {
				document.body.style.overflow = "unset";
				setVisible(false);
				setIsLearnMore(false);
			}, 451);
		}
	}, [props.popupState]);

	useEffect(() => {
		if (isLearnMore) {
			analyticsManager.recordEvent("GMI - Privacy Details Viewed", { is_onboarding: props.isOnboarding ?? true });
		}
	}, [isLearnMore])

	return (
		<div className={`fixed left-0 top-0 flex h-full w-full items-center justify-center bg-black bg-opacity-50 py-10 transition-all duration-450 ease-in-out z-30 ${props.popupState !== OauthPrivacyPopupState.hidden ? "opacity-1" : "opacity-0"} ${isVisible ? "visible overflow-hidden" : "invisible"}`}>
			<div className={`max-h-full w-full ${isLearnMore ? "max-w-3xl" : "max-w-[450px]"} overflow-y-auto rounded-2xl bg-white m-4`}>
				<div className="w-full">
					{isLearnMore ? (
						<div>
							<div className="flex flex-row justify-between items-center m-4">
								<div className="text-success-green font-bold font-primary text-xl">A little extra info...</div>
								<button onClick={() => props.setIsShow(false)}>
									<ExitIcon className="h-[26px] fill-brand-blue/50 hover:fill-brand-blue/100" />
								</button>
							</div>
							<div className="mx-auto text-left p-4 pt-0">
								<div className="flex flex-col items-center mb-1 gap-3">
									<div>
										<h1 className="text-brand-blue font-medium font-primary text-lg pb-2">How we work with {props.integrationType}</h1>
										<p className="text-brand-blue font-regular font-primary text-base  pb-3">We request {props.integrationType} permissions to display your newsletters in Meco. Chosen newsletters automatically skip your inbox and are added to a Meco {props.integrationType === "Gmail" ? "label" : "folder"} so you can read them in Meco while keeping your inbox clean. You can revert newsletters back anytime.</p>
									</div>
									<div>
										<h1 className="text-brand-blue font-medium font-primary text-lg pb-2">What permissions we ask for</h1>
										<p className="text-brand-blue font-regular font-primary text-base  pb-3">{props.integrationType === "Gmail" ? "Google" : "Microsoft" } requires us to request a bundle of permissions, even ones we don’t use (like send access). We only use what's needed to identify and organize your newsletters. We never send emails on your behalf.</p>
									</div>
									<div>
										<h1 className="text-brand-blue font-medium font-primary text-lg pb-2">Your emails & data are private</h1>
										<p className="text-brand-blue font-regular font-primary text-base  pb-3">Meco follows industry-leading security practices. We never store or access your personal emails, and we never sell your data. We collect minimal usage data to improve your experience. {props.integrationType === "Gmail" ? "Meco is verified by Google to meet privacy and security compliance standards." : "Meco is privacy and security protected."}</p>
									</div>
									<button className="cta-button w-full" onClick={() => props.agreeOnClick()}>
										Connect with {props.integrationType}
									</button>
								</div>
							</div>
						</div>
					) : (
						<div>
							<div className="flex flex-row justify-end m-4 mb-0">
								<button onClick={() => props.setIsShow(false)}>
									<ExitIcon className="h-[26px] fill-brand-blue/50 hover:fill-brand-blue/100" />
								</button>
							</div>
							<div className="mx-auto text-center p-4 pt-0">
								<div className="flex flex-col items-center mb-3 gap-3">
									<LockIcon className="w-[45px] fill-success-green" />
									<h1 className="text-brand-blue font-medium font-primary text-xl pb-2 leading-[1.2]">About permissions & privacy</h1>
									<p className="text-brand-blue font-regular font-primary text-base  pb-2">
									To connect {props.integrationType}, {props.integrationType === "Gmail" ? "Google requires us" : "we are required"} to request certain permissions - including some we don't actually need. We only use this access to display your newsletters in Meco, and your privacy stays protected: your emails remain on your device and are never stored on our servers. You can disconnect or move newsletters back anytime. <div className="text-success-green inline cursor-pointer font-medium" onClick={() => setIsLearnMore(true)}>Learn more</div>.
									</p>
									<button className="cta-button w-full" onClick={() => props.agreeOnClick()}>
										OK
									</button>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default OauthPrivacyPopup;
